export const buildURI = (data: string, uFEFF: boolean): string => {
  const type = 'text/calendar';
  const blob = new Blob([uFEFF ? '\uFEFF' : '', data], { type });
  const dataURI = `data:${type};charset=utf-8,${uFEFF ? '\uFEFF' : ''}${data}`;

  const URL = window.URL || window.webkitURL;

  return typeof URL.createObjectURL === 'undefined'
    ? dataURI
    : URL.createObjectURL(blob);
};
